export default {"src":"/_next/static/media/phone.24432af2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};